import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

import { logger } from 'src/lib/utils/logging';
import { ReCaptchaStatus } from './ReCaptchaStatus';
import { ReCaptchaV3 } from './ReCaptchaV3';

import { RECAPTCHA_V3_SITE_KEY } from './ReCaptchaV3SiteKey';



@Injectable({providedIn: 'root'})
export class ReCaptchaV3Service {
  constructor(
    @Inject(RECAPTCHA_V3_SITE_KEY) private siteKey: string,
    @Inject(DOCUMENT) private document: Document
  ) {}

  execute(action: string): PromiseLike<ReCaptchaStatus> {
    logger.log(`[ ReCaptchaV3Service ] execute : ${action}`);
    return this.reCaptcha.execute(this.siteKey, {action})
      .then(token => ({completed: true, token}));
  }

  private get reCaptcha(): ReCaptchaV3 {
    return this.document.defaultView['grecaptcha'];
  }
}
